import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { pageview } from 'gtm';

export const LocationTracker = () => {
    const location = useLocation();
    useEffect(() => {
        pageview(location.pathname + location.search);
    }, [location]);

    return null;
};
